var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticStyle:{"width":"100%"}},[_c('el-carousel',{staticClass:"showImg",attrs:{"height":_vm.carouseHeight,"interval":5000,"arrow":"always"}},[_c('el-carousel-item',[_c('img',{staticClass:"background",attrs:{"height":_vm.carouseHeight,"src":require("../../../static/img/home/showImg01.jpg")}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4715d140","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/homeShow.vue
// module id = null
// module chunks = 